var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Plus","transform":"translate(-118.5 -1006.5)"},[React.createElement("line",{"id":"Line_67","data-name":"Line 67","y2":"5","transform":"translate(121 1006.5)","fill":"none","stroke":"#022137","strokeWidth":"0.75","key":0}),React.createElement("line",{"id":"Line_68","data-name":"Line 68","y2":"5","transform":"translate(123.5 1009) rotate(90)","fill":"none","stroke":"#022137","strokeWidth":"0.75","key":1})]));
}

Plus.defaultProps = {"width":"5","height":"5","viewBox":"0 0 5 5"};

module.exports = Plus;

Plus.default = Plus;
